import { useContext } from 'react';
import { ListContext } from '@contexts/ListContext';

const useConfigurations = () => {
    const { cachedList } = useContext(ListContext);
    return  cachedList.generalconfigurations.items;
}

export default useConfigurations;
